import {
  Box,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  AutoCompleteController,
  Table,
} from '../../../components';
import {
  TFieldReport,
  TGetReportRequest,
} from '../../../types/mvpCharts';
import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useFormWithSchema } from '../../../utils/functions/yupFormTypescript';
import * as yup from 'yup';
import LaunchIcon from '@mui/icons-material/Launch';
import { useGetReportRequestsQuery } from '../../../services/mVPGraphQlService';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import nodatafound from '../../../assets/images/nodatafound.png';
// import { SideSheet } from '../reports/sideSheet';
import React from 'react';
import { useFilterContext } from '../../../services/mVPMapService/filterContext';

type applyFilterProps = {
  type: string;
  onNavigate?: (tabId: string, props?: any) => void; // 👈 add this
};

export const MVPDataTableInternal: React.FC<
  applyFilterProps
> = ({ onNavigate }) => {
  const formSchemaModal = yup.object({
    typeofuser: yup.string().required('Type is required'),
    name: yup.string().required('Name is required'),
    assignee: yup.string().default('All'),
  });
  const { filterValues: commonFilters } =
    useFilterContext();
  const {
    control,

    watch,
  } = useFormWithSchema(formSchemaModal, {
    mode: 'onTouched',
  });

  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const [tableData, setTableData] = useState<
    TFieldReport[]
  >([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [allTableData, setAllTableData] = useState<
    TFieldReport[]
  >([]);

  const user = useSelector(
    (state: RootState) => state.authUser
  );

  const wsId = useSelector(
    (state: RootState) => state.country.wsId
  );

  const queryParams: TGetReportRequest = {
    reportStatus: 'REPORT_ARCHIVED',
    pageSize: pageSize,
    pageNumber: pageNo + 1,
    wsId: wsId,
  };

  if (watch('assignee') === 'Me') {
    queryParams.actor = {
      actorId: user?.userId,
      actorName: user?.userName || ' ',
      actorType: user?.role,
    };
  }

  const { data: getTableData } =
    useGetReportRequestsQuery(queryParams, {
      refetchOnMountOrArgChange: true,
    });

  useEffect(() => {
    if (
      getTableData?.data?.GetReportRequests
        ?.reportInspections
    ) {
      setTableData(
        getTableData?.data?.GetReportRequests
          ?.reportInspections
      );
      setTotalCount(
        getTableData?.data?.GetReportRequests?.totalCount ||
          0
      );
      setAllTableData(
        getTableData?.data?.GetReportRequests
          ?.reportInspections
      );
    }
  }, [getTableData]);

  const assigneeList = [
    { label: 'All', value: 'All' },
    { label: 'Me', value: 'Me' },
  ];
  type Column<T, K extends keyof T> = {
    key: K;
    label: string;
    cellModifier?: (data: T) => React.ReactNode | string;
  };

  const columns: Column<
    TFieldReport,
    keyof TFieldReport
  >[] = [
    {
      key: 'fieldNo',
      label: 'Field Number',
      cellModifier: (data) => {
        return actionNode(data?.fieldNo);
      },
    },

    {
      key: 'createdTime',
      label: 'Requested on',
      cellModifier(data) {
        return dayjs(
          data?.createdTime?.seconds
            ? data?.createdTime?.seconds * 1000
            : 0
        ).format('DD/MM/YYYY');
      },
    },
    {
      key: 'createdActor',
      label: 'Requested by',
      cellModifier(data) {
        return data?.createdActor?.actorName;
      },
    },
    {
      key: 'geography',
      label: 'Region',
      cellModifier(data) {
        return data?.geography?.region;
      },
    },
    {
      key: 'geography',
      label: 'Village',
      cellModifier(data) {
        return data?.geography?.village;
      },
    },
    {
      key: 'assigneeActor',
      label: 'Assignee',
      cellModifier: (data) => {
        return data?.assigneeActor?.actorName;
      },
    },

    {
      key: 'people',
      label: 'Regional manager',
      cellModifier: (data) => {
        return data?.people?.regionManager;
      },
    },
    {
      key: 'people',
      label: 'FA',
      cellModifier: (data) => {
        return data?.people?.fa;
      },
    },
    {
      key: 'sowingTime',
      label: 'Sowing Date',
      cellModifier: (data) => {
        return data?.sowingTime?.seconds > 0
          ? dayjs(
              data?.sowingTime?.seconds
                ? data?.sowingTime?.seconds * 1000
                : 0
            ).format('DD/MM/YYYY')
          : '-';
      },
    },
    {
      key: 'feedback',
      label: 'Feedback',
      cellModifier: (data) => {
        return data?.feedback?.length > 20
          ? `${data?.feedback.slice(0, 20)}...`
          : data?.feedback;
      },
    },
  ];

  const actionNode = (tableRowData: number) => {
    const handleNavigation = () => {
      localStorage.setItem(
        'fieldId',
        tableRowData?.toString()
      );
      localStorage.setItem(
        'filterIndex',
        JSON?.stringify(commonFilters)
      );
      onNavigate?.('timeseries', {
        fieldId: tableRowData?.toString(),
      });
    };

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between">
        <Typography fontSize={13} fontWeight={600}>
          {tableRowData}
        </Typography>
        <Tooltip title="View field" arrow>
          <IconButton
            className="close-icon-btn"
            type="button"
            onClick={() => handleNavigation()}>
            <LaunchIcon className="close-icon" />
          </IconButton>
        </Tooltip>
      </Box>
    );
  };
  // const [hoveredRow, setHoveredRow] = useState<
  //   number | null
  // >(null);

  const handlePageChange = (
    event: React.MouseEvent | null,
    newPageNumber: number
  ) => {
    setPageNo(newPageNumber);
    setTableData(
      getPaginatedData(
        newPageNumber,
        pageSize,
        allTableData
      )
    );
  };

  const getPaginatedData = (
    newPageNumber: number,
    itemsPerPage: number,
    allItemsList: TFieldReport[]
  ) => {
    const indexOfLastItem =
      (newPageNumber + 1) * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentPageItems = allItemsList?.slice(
      indexOfFirstItem,
      indexOfLastItem
    );
    return [...currentPageItems];
  };

  const [selectedRowIds, setSelectedRowIds] = useState<
    number[]
  >([]);
  console.log(selectedRowIds);
  const handleSelectionChange = (ids: number[]) => {
    setSelectedRowIds(ids);
  };
  // const [selectedField, setSelectedField] =
  //   useState<TFieldReport | null>(null);
  // const [sideSheetOpen, setSideSheetOpen] = useState(false);

  // const openSideSheet = (data: TFieldReport) => {
  //   setSelectedField(data);
  //   setSideSheetOpen(true);
  // };

  // const closeSideSheet = () => {
  //   setSideSheetOpen(false);
  // };

  return (
    <>
      {user?.role !== 'FA' && (
        <div style={{ width: '200px' }}>
          <AutoCompleteController
            control={control}
            name="assignee"
            label="Assignee"
            placeholder="Select Assignee"
            options={assigneeList}
            disableClearable
          />
        </div>
      )}
      {tableData?.length > 0 ? (
        <Box>
          <Table
            columns={columns}
            data={tableData?.length ? tableData : []}
            rowsPerPage={pageSize}
            rowKey={'fieldNo'}
            setRowsPerPage={setPageSize}
            count={totalCount}
            page={pageNo}
            setPage={setPageNo}
            isLoading={false}
            rowsPerPageOptions={[pageSize]}
            pageChangeHandler={handlePageChange}
            onSelectionChange={handleSelectionChange}
          />
          {/* <SideSheet
            fieldId={selectedField?.fieldNo || 0}
            open={sideSheetOpen}
            onClose={closeSideSheet}
          /> */}
        </Box>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '90vh',
            width: '95vw',
            margin: 'auto',
            padding: '2vw',
          }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '3vw',
              border: '2px solid rgba(229, 229, 229, 1)',
              borderRadius: '8px',
              width: '100%',
              height: '100%',
            }}>
            <img
              src={nodatafound}
              alt="No Data Found"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};
